import {
	CustomAxiosErrorType,
	CustomMailFolderType,
	FilterableMailBoxUrlSlugs,
	InfiniteData,
	QueryStatus,
	MailBoxResponseType,
	MailBoxUrlSlugs,
	MailFoldersResponseType,
	PrivateMailBoxUrlSlugs,
} from '@ukpostbox/client-data';
import { CreateForwardingBatchType } from '@ukpostbox/client-data/lib/Types/ForwardingBatchTypes';
import { MailItemType } from '@ukpostbox/client-data/lib/Types/MailItemTypes';
import { Colour } from '@ukpostbox/frontend-framework';

export type MailboxSectionFilterType = {
	folder: string;
	filters: MailboxFilterType;
};

export type MailboxFilterType = {
	[key: string]: MailboxFilterValuesType;
};

export type MailboxFilterValuesType = {
	label: string;
	value: any;
	group?: string;
	isSelectType?: boolean;
};

export type MailboxInfoType = {
	folderId: number;
	folderName: string;
	folderSlug: string;
	folderColour?: Colour;
	mailTagIds?: number;
	customFolderId?: number;
	incomingRecipientNames?: number;
};

export interface MailboxProviderType {}

export type CustomMailFoldersType = {
	id: number;
	description: string;
	colour: Colour | string;
	count?: number;
	unreadCount?: number;
	parentFolderId?: number | null;
	childFolders?: boolean;
};

export type InlineUpdateType = {
	data: any;
	success: boolean;
	updating: boolean;
	error: boolean;
};

export interface MailboxContextType {
	folderStatus: QueryStatus;
	folderData?: InfiniteData<MailFoldersResponseType>;
	folderError: CustomAxiosErrorType | null;

	customFolderStatus: QueryStatus;
	customFolderData?: Array<CustomMailFolderType>;
	customFolderError: CustomAxiosErrorType | null;

	mailItemStatus: QueryStatus;
	mailItemData?: MailItemType;
	mailItemError: CustomAxiosErrorType | null;

	mailItemActionsError: Error | null;
	mailItemActionsStatus: QueryStatus;

	allSelected: boolean;
	visibleSelected: boolean;
	visibleIndeterminate: boolean;
	selectedItems: Array<any>;
	selectedItemsRef: any;

	selectionActions: Array<any>;

	gridView: boolean;
	gridSize: any;

	searchParams: URLSearchParams;
	searchActive: boolean;
	searchReset: boolean;

	userFilters: FilterableMailBoxUrlSlugs;
	privateFilters: PrivateMailBoxUrlSlugs;
	parsedFilters: MailBoxUrlSlugs;

	MoveSelectedItems: (targetFolderId: number) => void;
	MoveItemsToFolder: (targetFolderId: number) => void;
	RemoveItemsFromFolder: (currentFolderId: number) => void;
	MarkMailItemAsRead: () => void;
	UpdateMailTags: (tag: any, checked: boolean) => void;
	UpdateMailNote: (noteValue: string, oldNoteValue: string) => void;
	ActionMailItemsUi: (actionName: string) => void;
	UndoActionMailItems: () => void;
	ActionMailItems: (actionId: number, actionName: string, successCallback?: any) => void;

	ActionItem: (data: InfiniteData<MailBoxResponseType> | MailItemType, actionId: number) => void;
	ActionItemComplete: (actionId: number) => void;

	ResetSelection: () => void;
	ToggleSelected: (key: any, totalItems: number, value?: boolean) => void;
	ToggleVisible: (data: any, key: string, value: boolean) => void;
	ToggleAll: (value: boolean) => void;

	SetGridView: (value: boolean) => void;
	SetGridSize: (value: number) => void;

	FilterActions: (data: any, selected: any) => void;

	ToggleCreateCustomFolderModal: (state: boolean) => void;
	ToggleDeleteCustomFolderModal: (state: boolean) => void;

	CreateCustomFolder: (newFolderData: CustomMailFolderType, SuccessCallback?: (newFolderId: number) => void) => void;
	EditCustomFolder: (editFolderData: CustomMailFolderType, SuccessCallback?: () => void) => void;
	DeleteCustomFolder: (deleteChildFolders?: boolean) => void;
	MoveCustomFolder: (targetFolderId: number | null, currentFolderId: number) => void;
	UpdateActiveFolderData: (folderId: number) => void;

	HandleFolderMove: (result: any) => void;

	CreateForwardingBatch: (data: CreateForwardingBatchType) => void;

	ShowFilters: () => void;
	ClearFilters: () => void;
	RemoveFilter: (filterName: keyof FilterableMailBoxUrlSlugs) => void;
	SetFilters: (filters: FilterableMailBoxUrlSlugs) => void;

	RemoveUrlSearchParam: (key: string) => void;
	UpdateUrlSearchParams: (newParams: URLSearchParams) => void;
}

export enum MailTypeEnum {
	'Parcel' = 0,
	'Letter' = 1,
}

export enum MailTypeFilterEnum {
	'All' = -1,
	'Parcels' = 0,
	'Letters' = 1,
}
